// extracted by css-extract-rspack-plugin
var _1 = "card-ZEUFDT";
var _2 = "text-qpAc74";
export { _1 as "card", _2 as "text" }
